export var PaginationItemType;
(function (PaginationItemType) {
    PaginationItemType["Page"] = "page";
    PaginationItemType["Dots"] = "dots";
    PaginationItemType["ArrowLeft"] = "arrowLeft";
    PaginationItemType["ArrowRight"] = "arrowRight";
})(PaginationItemType || (PaginationItemType = {}));
